import React from 'react';
import toast from 'react-hot-toast';
import { updateShippingDetails } from '../../../services/shipping';
import ShippingModal from '../ShippingModal';
import { applyBulkShippingUpdates, summarizeBulkUpdateResults } from './helpers';

const BulkShippingModal = ({ open, onClose, selectedRows = [], order, onComplete }) => {
  const firstRow = selectedRows[0];
  const count = selectedRows.length;

  const handleSubmit = async (payload) => {
    const results = await applyBulkShippingUpdates(selectedRows, payload, updateShippingDetails);
    const outcome = summarizeBulkUpdateResults(results);

    if (outcome.failed === 0) {
      toast.success(`Shipping updated for ${outcome.succeeded} products`);
      await onComplete?.();
      return;
    }
    if (outcome.succeeded > 0) {
      toast.error(
        `Shipping updated for ${outcome.succeeded} of ${outcome.total} products. ` +
        `${outcome.failed} update${outcome.failed === 1 ? '' : 's'} failed.`
      );
      await onComplete?.();
      return;
    }
    toast.error(`Failed to update shipping for ${outcome.total} products. Please try again.`);
  };

  if (!open || !firstRow?.id || count < 2) return null;

  return (
    <ShippingModal
      open={open}
      onClose={onClose}
      setOpen={() => {}}
      product={firstRow}
      selectedShippingDetailsId={firstRow.id}
      sourceShippingId={firstRow.id}
      order={order}
      onSubmitPayload={handleSubmit}
      title={`Edit Shipping for ${count} Products`}
      helperText={`Changes will be applied independently to all ${count} selected products. The first selected product is used as the template.`}
      submitLabel={`Apply to ${count} Products`}
    />
  );
};

export default BulkShippingModal;
